import type { Response } from './_type';

import { useGet } from '~/common/hooks';

/** useChatSessions */
export const useGetConversation = (external_user: string, session_id: string) => {
  /** URL */
  const url = `/users/${external_user}/chat-sessions/${session_id}`;

  /** return */
  return useGet<Response>(url, undefined, {
    enabled: !!session_id && !!external_user,
    showError: false,
  });
};
